import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../../helpers/language-context';
import { supabase } from '../../../supabaseClient';

const SubsidiraryCard = ({ subsidiary }) => {
  const { language } = useLanguage();
  const [isHovered, setIsHovered] = useState(false);

  const title = subsidiary['name'];
  const description = language === 'en' ? subsidiary['description_en'] : subsidiary['description_ms'];
  const logo = subsidiary['logo'];


  return (
    <div
      className="relative bg-white p-6 pt-20 space-y-8 rounded-2xl overflow-hidden transition-all duration-300 border-2 border-transparent hover:border-[#FDA729] hover:scale-105 group flex flex-col"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={logo}
        alt={title}
        className="max-w-[60%] h-auto"
      />
      <div className="items-center justify-between space-y-4 flex-1">
        <h3 className={`text-2xl font-bold  ${isHovered ? 'text-[#444444]' : 'text-[#ABABAB] '
          }`}>{title}</h3>
        <p className={`text-sm transition-all duration-300 ${isHovered ? 'text-[#444444]' : 'text-[#ABABAB] '
          } overflow-hidden`}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default function SubsidiaryList() {
  const [subsidiaries, setSubsidiaries] = useState([]);

  useEffect(() => {
    const fetchSubsidiaries = async () => {
      const { data, error } = await supabase
        .from('subsidiaries')
        .select('*')
        .order('id', { ascending: true });
      if (!error) setSubsidiaries(data);
    };
    fetchSubsidiaries();
  }, []);

  return (
    <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {subsidiaries.map((subsidiary, index) => (
        <SubsidiraryCard key={index} subsidiary={subsidiary} />
      ))}
    </div>
  );
}